const GET_AZURE_ACTIVE_ALERT = "GET_AZURE_ACTIVE_ALERT";
const GET_AZURE_ACTIVE_ALERT_SUCCESS = "GET_AZURE_ACTIVE_ALERT_SUCCESS";
const GET_AZURE_ACTIVE_ALERT_ERROR = "GET_AZURE_ACTIVE_ALERT_ERROR";

export {
  GET_AZURE_ACTIVE_ALERT,
  GET_AZURE_ACTIVE_ALERT_SUCCESS,
  GET_AZURE_ACTIVE_ALERT_ERROR,
};
